import React from 'react';
import { Container } from './styles';
import Table from '../../../../../components/Table';
import { ICustomerNFItem } from '../../../../../store/ducks/download-area/types';
import { formatCurrency } from '../../../../../utils/formatNumbers';
import Tag from '@gerdau/hefesto/Tag/Tag';
import moment from 'moment';
import NFDownloadButton from './NFDownloadButton';

interface INFTable {
  data: ICustomerNFItem[];
}

const NFTable: React.FC<INFTable> = ({ data }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ordersStatusList: any = {
    billed: {
      description: 'Faturado',
      variant: 'success'
    },
    cancelled: {
      description: 'Cancelado',
      variant: 'danger'
    },
    shipment: {
      description: 'Em carregamento',
      variant: 'primary'
    },
    delivery: {
      description: 'Em remessa',
      variant: 'info'
    },
    pending: {
      description: 'Saldo',
      variant: 'neutral'
    }
  };

  const getColumns = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const columns: any = [
      {
        title: 'Nº do pedido',
        dataIndex: 'orderNumber',
        sorter: (a: ICustomerNFItem, b: ICustomerNFItem) =>
          Number(a.orderNumber) - Number(b.orderNumber),
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Nº da NF',
        sorter: (a: ICustomerNFItem, b: ICustomerNFItem) =>
          Number(a.invoiceNumber.replace('-', '')) -
          Number(b.invoiceNumber.replace('-', '')),
        dataIndex: 'invoiceNumber',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Data da emissão',
        dataIndex: 'itemBillingDate',
        sorter: (a: ICustomerNFItem, b: ICustomerNFItem) =>
          moment(a.itemBillingDate, 'YYYY-MM-DD').toDate().getTime() -
          moment(b.itemBillingDate, 'YYYY-MM-DD').toDate().getTime(),
        render: (date: string) => (
          <span>
            {date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'}
          </span>
        )
      },
      {
        title: 'Status',
        dataIndex: 'status',
        sorter: (a: ICustomerNFItem, b: ICustomerNFItem) =>
          a.status.localeCompare(b.status),
        render: (status: string) => (
          <Tag variant={ordersStatusList[status].variant}>
            {ordersStatusList[status].description}
          </Tag>
        )
      },
      {
        title: 'Valor total',
        dataIndex: 'totalValue',
        sorter: (a: ICustomerNFItem, b: ICustomerNFItem) =>
          +a.totalValue.toString().replace(',', '') -
          +b.totalValue.toString().replace(',', ''),
        render: (text: string) =>
          !text || isNaN(Number(text)) ? (
            'Indisponível'
          ) : (
            <>R$ {formatCurrency(text)}</>
          )
      },
      {
        title: 'Baixar nota fiscal',
        dataIndex: '',
        render: (data: ICustomerNFItem) => <NFDownloadButton item={data} />
      }
    ];

    return columns;
  };

  return (
    <Container>
      <Table columns={getColumns()} data={data} hasPagination />
    </Container>
  );
};

export default NFTable;
